var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r3"},[_c('div',{staticClass:"contents"},_vm._l((_vm.dataList),function(item){return _c('div',{key:item,staticClass:"r3-item"},[_vm._l((_vm.iconlist),function(del,i){return _c('img',{key:i,class:`icon${i}`,attrs:{"src":del,"alt":""}})}),_c('img',{staticClass:"hover-img",attrs:{"src":item.value0,"alt":""}})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }